<template>
  <div>
    <b-breadcrumb :items="items" style="background-color: transparent"></b-breadcrumb>
    <b-container>
      <b-row>
        <b-col sm="12" style="padding: 34px 0">
          <h1 class="text-center">
            Modulos
          </h1>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid>
      <b-container>
        <b-row align-h="center">
          <b-col
            sm="10"
            md="3"
            v-for="modulo in modules"
            :key="modulo.id"
            style="padding-bottom: 20px;"
          >
            <router-link v-bind:to="modulo.path">
              <b-card  
                footer-tag="footer" 
                class="hoverme">
                <b-card-body class="text-center">
                    <img v-bind:src="modulo.cover" alt="modulos" width="100%" >                  
                </b-card-body>
                <template v-slot:footer>
                  <p class="text-center" style="margin:0">
                    {{modulo.title}}
                  </p>
                </template>
              </b-card>
            </router-link>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Modulos",
  data() {
    return {
      modules: [
        {
          id: 1,
          title: "Rim Normal",
          cover: require("../assets/modulo01/capa.png"),
          path: "/rim-normal"
        },
        {
          id: 2,
          title: "Nefrite Lupica",
          cover: require("../assets/NefriteLupica/capa.png"),
          path: "/nefrite-lupica"
        }
      ],
      items: [
          {
            text: 'Home',
            to: { name: 'categories' }
          },
          {
            text: 'Modulos',
            to: { name: 'modulos' }
          }
        ]
    };
  }
};
</script>

<style scoped>
a {
  color: #2c3e50;
}
.hoverme {
  box-shadow: 0px 7px 15px rgba(42, 42, 42, 0.667);
  transition: 0.5s;
}
.hoverme:hover {
  box-shadow: 0px 3px 5px rgba(42, 42, 42, 0.667);
  transition: 0.5s;
}
.card-body {
  padding: 0;
}
</style>